'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BoostDialog } from '@/components/market/boost-dialog';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { FlashIcon } from '@/components/ui/icon/glyphs';
import { useAuthGate } from '@/hooks/use-auth-gate';
import { canBoostMarket } from '@/lib/market/can-boost-market';
interface MarketBoostersEmptyProps {
  marketPubkey: string;
  marketStatus: string;
}
export function MarketBoostersEmpty(t0) {
  const $ = _c(20);
  const {
    marketPubkey,
    marketStatus
  } = t0;
  const t = useTranslations("market.boosters");
  const {
    withAuth
  } = useAuthGate();
  const [boostOpen, setBoostOpen] = useState(false);
  let t1;
  if ($[0] !== marketStatus) {
    t1 = canBoostMarket({
      status: marketStatus
    });
    $[0] = marketStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const boostable = t1;
  let t2;
  if ($[2] !== boostable || $[3] !== t) {
    t2 = boostable ? t("empty_title") : t("no_boosters_closed");
    $[2] = boostable;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== boostable || $[6] !== t) {
    t3 = boostable ? t("empty_subtitle") : t("empty_subtitle_unavailable");
    $[5] = boostable;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== boostable || $[9] !== t || $[10] !== withAuth) {
    t4 = boostable ? <AnimatedButton onClick={withAuth(() => setBoostOpen(true))}>{t("empty_cta")}</AnimatedButton> : undefined;
    $[8] = boostable;
    $[9] = t;
    $[10] = withAuth;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== boostOpen || $[13] !== marketPubkey) {
    t5 = <BoostDialog marketPubkey={marketPubkey} open={boostOpen} onOpenChange={setBoostOpen} />;
    $[12] = boostOpen;
    $[13] = marketPubkey;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <EmptyState framed={true} icon={FlashIcon} title={t2} description={t3} data-testid="market-boosters-empty" action={t4}>{t5}</EmptyState>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}